import type {JobPreviewActions} from 'src/action-creators/job-preview';
import type {JobPreviewData, MatchingCandidate} from 'src/types/job-preview';
import {
  RECEIVE_PREVIEW_LIST,
  PREVIEW_ID,
  RECEIVE_LIST_COUNT,
  REFETCH,
  SAVE_CANDIDATE_DETAIL,
  SAVE_SELECTED_CANDIDATE,
} from 'src/action-creators/job-preview';


export type JobPreviewState = {
  jobs: JobPreviewData;
  total: number;
  id: string | null;
  refetch: boolean;
  matchingCandidate: MatchingCandidate | null;
  selectedCandidates: MatchingCandidate[] | null;
};

const initialState = {
  jobs: {
    columns: [],
    data: [],
  },
  total: 0,
  id: null,
  refetch: false,
  matchingCandidate: null,
  selectedCandidates: null,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly jobs: { readonly columns: readonly []; readonly data: readonly []; }; readonly total: 0; readonly id: null; readonly refetch: false; readonly matchingCandidate: null; readonly selectedCandidates: null; }' is not assignable to type 'JobPreviewState'.
  state: JobPreviewState | null | undefined = initialState,
  action: JobPreviewActions,
): JobPreviewState => {
  switch (action.type) {
    case RECEIVE_PREVIEW_LIST: {
      // @ts-expect-error - TS2322 - Type '{ jobs: JobPreviewData; total?: number | undefined; id?: string | null | undefined; refetch?: boolean | undefined; matchingCandidate?: MatchingCandidate | null | undefined; selectedCandidates?: MatchingCandidate[] | ... 1 more ... | undefined; }' is not assignable to type 'JobPreviewState'.
      return {
        ...state,
        jobs: action.payload.jobs,
      };
    }
    case PREVIEW_ID: {
      // @ts-expect-error - TS2322 - Type '{ id: string; jobs?: JobPreviewData | undefined; total?: number | undefined; refetch?: boolean | undefined; matchingCandidate?: MatchingCandidate | null | undefined; selectedCandidates?: MatchingCandidate[] | ... 1 more ... | undefined; }' is not assignable to type 'JobPreviewState'.
      return {
        ...state,
        id: action.payload.id,
      };
    }
    case RECEIVE_LIST_COUNT: {
      // @ts-expect-error - TS2322 - Type '{ total: number; jobs?: JobPreviewData | undefined; id?: string | null | undefined; refetch?: boolean | undefined; matchingCandidate?: MatchingCandidate | null | undefined; selectedCandidates?: MatchingCandidate[] | ... 1 more ... | undefined; }' is not assignable to type 'JobPreviewState'.
      return {
        ...state,
        total: action.payload.total,
      };
    }
    case REFETCH: {
      // @ts-expect-error - TS2322 - Type '{ refetch: boolean; jobs?: JobPreviewData | undefined; total?: number | undefined; id?: string | null | undefined; matchingCandidate?: MatchingCandidate | null | undefined; selectedCandidates?: MatchingCandidate[] | ... 1 more ... | undefined; }' is not assignable to type 'JobPreviewState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        refetch: !state.refetch,
      };
    }
    case SAVE_CANDIDATE_DETAIL: {
      // @ts-expect-error - TS2322 - Type '{ matchingCandidate: MatchingCandidate; jobs?: JobPreviewData | undefined; total?: number | undefined; id?: string | null | undefined; refetch?: boolean | undefined; selectedCandidates?: MatchingCandidate[] | ... 1 more ... | undefined; }' is not assignable to type 'JobPreviewState'.
      return {
        ...state,
        matchingCandidate: action.payload,
      };
    }
    case SAVE_SELECTED_CANDIDATE: {
      // @ts-expect-error - TS2322 - Type '{ selectedCandidates: MatchingCandidate[]; jobs?: JobPreviewData | undefined; total?: number | undefined; id?: string | null | undefined; refetch?: boolean | undefined; matchingCandidate?: MatchingCandidate | ... 1 more ... | undefined; }' is not assignable to type 'JobPreviewState'.
      return {
        ...state,
        selectedCandidates: action.payload,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'JobPreviewState | null' is not assignable to type 'JobPreviewState'.
  return state;
};
